import { render } from "./importedServices.vue?vue&type=template&id=5ab4e958&scoped=true"
import script from "./importedServices.vue?vue&type=script&lang=js"
export * from "./importedServices.vue?vue&type=script&lang=js"

import "./importedServices.vue?vue&type=style&index=0&id=5ab4e958&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab4e958"]])

export default __exports__